import '../../CommonStyles.scss';
import './FinancialTab.scss';
import ArrGrowthChart from './components/ArrGrowthChart/ArrGrowthChart';
import CertRevenueBreakdownChart from './components/CertRevenueBreakdownChart/CertRevenueBreakdownChart';
import RefundsChart from './components/RefundsChart/RefundsChart';
import MrrCertRevenueChart from './components/MrrCertRevenueChart/MrrCertRevenueChart';
import SubscriptionActivityChart from './components/SubscriptionActivityChart/SubscriptionActivityChart';
import ChurnRateChart from './components/ChurnRateChart/ChurnRateChart';
import FinancialKpis from './components/FinancialKpis/FinancialKpis';
import MonthlyPnLTable from './components/MonthlyPnLTable/MonthlyPnLTable';

export const FinancialTab = () => {
  return (
    <div className='analytics-tab financial-tab'>
      <div className='overview-section'>
        <p className='section-title'>Key metrics — last 6 months</p>
        <div className='section-grid metrics'>
          <FinancialKpis />
        </div>
      </div>

      <div className='overview-section'>
        <p className='section-title'>Revenue</p>
        <div className='section-grid trends'>
          <CertRevenueBreakdownChart />
          <RefundsChart />
        </div>
      </div>

      <div className='overview-section'>
        <p className='section-title'>Recurring revenue</p>
        <div className='section-grid trends'>
          <MrrCertRevenueChart />
          <ArrGrowthChart />
        </div>
      </div>

      <div className='overview-section'>
        <p className='section-title'>Subscriptions</p>
        <div className='section-grid trends'>
          <SubscriptionActivityChart />
          <ChurnRateChart />
        </div>
      </div>

      <div className='overview-section'>
        <MonthlyPnLTable />
      </div>
    </div>
  );
};

export default FinancialTab;
